// extracted by mini-css-extract-plugin
module.exports = {"options":"Options_options__2j77s","button":"Options_button__IkEJt","favorite":"Options_favorite__1YRz5"};